import { useContext } from 'react';

import { StoreContext } from './StoreContext';
import RootStore from '../RootStore';

export const useStores = () => {
  return useContext<RootStore>(StoreContext);
};
